export const analyzeDefaultData = {
  originalText:
    '貴社が提供するプロジェクトマネジメントの研修やキャリアアップの機会を活かし、今後は技術者としてだけでなく、マネジメントやプロジェクト推進のスキルも身につけ、ゼネラリストとしてのキャリアを築いていきたいと考えております。',
  words: [
    {
      surface: '貴社',
      reading_katakana: 'キシャ',
      reading_hiragana: 'きしゃ',
      reading_romaji: 'kisha',
      pos: '名詞',
    },
    {
      surface: 'が',
      reading_katakana: 'ガ',
      reading_hiragana: 'が',
      reading_romaji: 'ga',
      pos: '助詞',
    },
    {
      surface: '提供',
      reading_katakana: 'テイキョウ',
      reading_hiragana: 'ていきょう',
      reading_romaji: 'teikyou',
      pos: '名詞',
    },
    {
      surface: 'する',
      reading_katakana: 'スル',
      reading_hiragana: 'する',
      reading_romaji: 'suru',
      pos: '動詞',
    },
    {
      surface: 'プロジェクト',
      reading_katakana: 'プロジェクト',
      reading_hiragana: 'ぷろじぇくと',
      reading_romaji: 'purojekuto',
      pos: '名詞',
    },
    {
      surface: 'マネジメント',
      reading_katakana: 'マネジメント',
      reading_hiragana: 'まねじめんと',
      reading_romaji: 'manejimento',
      pos: '名詞',
    },
    {
      surface: 'の',
      reading_katakana: 'ノ',
      reading_hiragana: 'の',
      reading_romaji: 'no',
      pos: '助詞',
    },
    {
      surface: '研修',
      reading_katakana: 'ケンシュウ',
      reading_hiragana: 'けんしゅう',
      reading_romaji: 'kenshuu',
      pos: '名詞',
    },
    {
      surface: 'や',
      reading_katakana: 'ヤ',
      reading_hiragana: 'や',
      reading_romaji: 'ya',
      pos: '助詞',
    },
    {
      surface: 'キャリア',
      reading_katakana: 'キャリア',
      reading_hiragana: 'きゃりあ',
      reading_romaji: 'kyaria',
      pos: '名詞',
    },
    {
      surface: 'アップ',
      reading_katakana: 'アップ',
      reading_hiragana: 'あっぷ',
      reading_romaji: 'appu',
      pos: '名詞',
    },
    {
      surface: 'の',
      reading_katakana: 'ノ',
      reading_hiragana: 'の',
      reading_romaji: 'no',
      pos: '助詞',
    },
    {
      surface: '機会',
      reading_katakana: 'キカイ',
      reading_hiragana: 'きかい',
      reading_romaji: 'kikai',
      pos: '名詞',
    },
    {
      surface: 'を',
      reading_katakana: 'ヲ',
      reading_hiragana: 'を',
      reading_romaji: 'wo',
      pos: '助詞',
    },
    {
      surface: '活かし',
      reading_katakana: 'イカシ',
      reading_hiragana: 'いかし',
      reading_romaji: 'ikashi',
      pos: '動詞',
    },
    {
      surface: '、',
      reading_katakana: '、',
      reading_hiragana: '、',
      reading_romaji: ',',
      pos: '記号',
    },
    {
      surface: '今後',
      reading_katakana: 'コンゴ',
      reading_hiragana: 'こんご',
      reading_romaji: 'kongo',
      pos: '名詞',
    },
    {
      surface: 'は',
      reading_katakana: 'ハ',
      reading_hiragana: 'は',
      reading_romaji: 'ha',
      pos: '助詞',
    },
    {
      surface: '技術',
      reading_katakana: 'ギジュツ',
      reading_hiragana: 'ぎじゅつ',
      reading_romaji: 'gijutsu',
      pos: '名詞',
    },
    {
      surface: '者',
      reading_katakana: 'シャ',
      reading_hiragana: 'しゃ',
      reading_romaji: 'sha',
      pos: '名詞',
    },
    {
      surface: 'として',
      reading_katakana: 'トシテ',
      reading_hiragana: 'として',
      reading_romaji: 'toshite',
      pos: '助詞',
    },
    {
      surface: 'だけ',
      reading_katakana: 'ダケ',
      reading_hiragana: 'だけ',
      reading_romaji: 'dake',
      pos: '助詞',
    },
    {
      surface: 'で',
      reading_katakana: 'デ',
      reading_hiragana: 'で',
      reading_romaji: 'de',
      pos: '助動詞',
    },
    {
      surface: 'なく',
      reading_katakana: 'ナク',
      reading_hiragana: 'なく',
      reading_romaji: 'naku',
      pos: '助動詞',
    },
    {
      surface: '、',
      reading_katakana: '、',
      reading_hiragana: '、',
      reading_romaji: ',',
      pos: '記号',
    },
    {
      surface: 'マネジメント',
      reading_katakana: 'マネジメント',
      reading_hiragana: 'まねじめんと',
      reading_romaji: 'manejimento',
      pos: '名詞',
    },
    {
      surface: 'や',
      reading_katakana: 'ヤ',
      reading_hiragana: 'や',
      reading_romaji: 'ya',
      pos: '助詞',
    },
    {
      surface: 'プロジェクト',
      reading_katakana: 'プロジェクト',
      reading_hiragana: 'ぷろじぇくと',
      reading_romaji: 'purojekuto',
      pos: '名詞',
    },
    {
      surface: '推進',
      reading_katakana: 'スイシン',
      reading_hiragana: 'すいしん',
      reading_romaji: 'suishin',
      pos: '名詞',
    },
    {
      surface: 'の',
      reading_katakana: 'ノ',
      reading_hiragana: 'の',
      reading_romaji: 'no',
      pos: '助詞',
    },
    {
      surface: 'スキル',
      reading_katakana: 'スキル',
      reading_hiragana: 'すきる',
      reading_romaji: 'sukiru',
      pos: '名詞',
    },
    {
      surface: 'も',
      reading_katakana: 'モ',
      reading_hiragana: 'も',
      reading_romaji: 'mo',
      pos: '助詞',
    },
    {
      surface: '身',
      reading_katakana: 'ミ',
      reading_hiragana: 'み',
      reading_romaji: 'mi',
      pos: '名詞',
    },
    {
      surface: 'に',
      reading_katakana: 'ニ',
      reading_hiragana: 'に',
      reading_romaji: 'ni',
      pos: '助詞',
    },
    {
      surface: 'つけ',
      reading_katakana: 'ツケ',
      reading_hiragana: 'つけ',
      reading_romaji: 'tsuke',
      pos: '動詞',
    },
    {
      surface: '、',
      reading_katakana: '、',
      reading_hiragana: '、',
      reading_romaji: ',',
      pos: '記号',
    },
    {
      surface: 'ゼネラリスト',
      reading_katakana: 'ゼネラリスト',
      reading_hiragana: 'ぜねらりすと',
      reading_romaji: 'zenerarisuto',
      pos: '名詞',
    },
    {
      surface: 'として',
      reading_katakana: 'トシテ',
      reading_hiragana: 'として',
      reading_romaji: 'toshite',
      pos: '助詞',
    },
    {
      surface: 'の',
      reading_katakana: 'ノ',
      reading_hiragana: 'の',
      reading_romaji: 'no',
      pos: '助詞',
    },
    {
      surface: 'キャリア',
      reading_katakana: 'キャリア',
      reading_hiragana: 'きゃりあ',
      reading_romaji: 'kyaria',
      pos: '名詞',
    },
    {
      surface: 'を',
      reading_katakana: 'ヲ',
      reading_hiragana: 'を',
      reading_romaji: 'wo',
      pos: '助詞',
    },
    {
      surface: '築い',
      reading_katakana: 'キズイ',
      reading_hiragana: 'きずい',
      reading_romaji: 'kizui',
      pos: '動詞',
    },
    {
      surface: 'て',
      reading_katakana: 'テ',
      reading_hiragana: 'て',
      reading_romaji: 'te',
      pos: '助詞',
    },
    {
      surface: 'いき',
      reading_katakana: 'イキ',
      reading_hiragana: 'いき',
      reading_romaji: 'iki',
      pos: '動詞',
    },
    {
      surface: 'たい',
      reading_katakana: 'タイ',
      reading_hiragana: 'たい',
      reading_romaji: 'tai',
      pos: '助動詞',
    },
    {
      surface: 'と',
      reading_katakana: 'ト',
      reading_hiragana: 'と',
      reading_romaji: 'to',
      pos: '助詞',
    },
    {
      surface: '考え',
      reading_katakana: 'カンガエ',
      reading_hiragana: 'かんがえ',
      reading_romaji: 'kangae',
      pos: '動詞',
    },
    {
      surface: 'て',
      reading_katakana: 'テ',
      reading_hiragana: 'て',
      reading_romaji: 'te',
      pos: '助詞',
    },
    {
      surface: 'おり',
      reading_katakana: 'オリ',
      reading_hiragana: 'おり',
      reading_romaji: 'ori',
      pos: '動詞',
    },
    {
      surface: 'ます',
      reading_katakana: 'マス',
      reading_hiragana: 'ます',
      reading_romaji: 'masu',
      pos: '助動詞',
    },
    {
      surface: '。',
      reading_katakana: '。',
      reading_hiragana: '。',
      reading_romaji: '.',
      pos: '記号',
    },
  ],
};
